import {Box, Typography} from '@mui/material';
import React from 'react';
import {Button} from '../Button';

export type EmptyStateProps = {
  /** Decorative; 28px, text.secondary. */
  icon?: React.ReactNode;
  title: string;
  description?: string;
  /** At most one action. */
  action?: {label: string; onClick: () => void};
  /** The title's heading level in its context. Default 2. */
  headingLevel?: 2 | 3 | 4;
};

/** "Nothing here yet": a dashed line.control box, a heading, one action. */
export const EmptyState = ({
  icon,
  title,
  description,
  action,
  headingLevel = 2,
}: EmptyStateProps) => (
  <Box
    data-testid="empty-state"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      gap: 1,
      py: '28px',
      px: 2,
      border: '1px dashed',
      borderColor: 'border.control',
      borderRadius: 1.5,
    }}>
    {icon && (
      <Box
        data-testid="empty-state-icon"
        aria-hidden
        sx={{
          display: 'flex',
          color: 'text.secondary',
          fontSize: 28,
          '& svg': {fontSize: 28},
        }}>
        {icon}
      </Box>
    )}
    <Typography
      component={`h${headingLevel}`}
      variant="title"
      sx={{color: 'text.primary', fontSize: '0.9375rem'}}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{color: 'text.secondary', maxWidth: 400}}>
        {description}
      </Typography>
    )}
    {action && (
      <Button sx={{mt: 1}} onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </Box>
);
